import React from 'react';
import {connect} from "react-redux";
import {hashHistory} from "react-router";
import $ from 'jquery';

import {getCurrentLayout} from "../appLayout";
import ShoppingCartMobileHeader from "./shoppingCartMobileHeader";
import ShoppingCartItemsList from "./shoppingCartItemsList";
import InstView from "../installation/instView";

import {
  clickQuestionNo, setCameFromPage, toggleBathroomVisualizerOpen, toggleSelectionWindow, toggleInstOpened
} from "../../actions/actionFunctions";

import {browserIsSafari} from "../../misc/helpers";
// import config from "../../config";
import Analytics from './../../analytics';
import RecentlyViewedItems from "./recentlyViewedItems";
import ShoppingCart from "./shoppingCart";
import DepositDisclaimer from "./depositDisclaimer";
import {changeQTRoutePath} from "../../misc/changeRoutePath";
import ShoppingCartFooter from "./shoppingCartFooter";
import ShoppingCartCanvas from "./shoppingCartCanvas";
import ShoppingCartInstallationQuestion from "./shoppingCartInstallationQuestion";
import Quotes from "./quotes";
import NoInternetOverlay from "../ui/noInternetOverlay";
import HardcodedCanvasImage from "../visComponents/hardcodedCanvasImage";
import PriceWorksheetView from "../priceWorksheet/priceWorksheetView";
import {togglePriceWorksheetOpened} from "../../actions/priceWorksheetActions";


class ShoppingCartMobile extends ShoppingCart {

  constructor(props) {
    super(props);
    this.scartContent = null;
    this.state = {
      questionShown: false,
      activePane: "",
      activePaneIndex: 0,
      containerHeight: 0,
    };
    this.needToShowQuestionAgain = false;
  }

  componentDidMount() {
    document.body.classList.add('body--materials');
    // const selectionGroup = this.props.selectionGroup;

    // console.log('selectionGroup', selectionGroup);

    // this.setState({
    //   activePart: layout.parts[selectionGroup]
    // });

    if (!this.props.questionNoClicked) {
      this.scartContent.addEventListener('scroll', this.onContentScroll);
    }
    if (browserIsSafari()) {
      ['resize', 'scroll'].forEach((e) => {
        window.addEventListener(e, this.handleResize);
      });
    }
    this.handleResize();
  }

  componentWillUnmount() {
    if (browserIsSafari()) {
      ['resize', 'scroll'].forEach((e) => {
        window.removeEventListener(e, this.handleResize);
      });
    }
    document.body.classList.remove('body--materials');
    this.scartContent.removeEventListener('scroll', this.onContentScroll);
  }

  // componentWillReceiveProps(nextProps) {
    // if (this.props.selectionGroup !== nextProps.selectionGroup) {
    //   this.setState({
    //     activePart: layout.parts[nextProps.selectionGroup],
    //     activePartRelatedItemIndex: 0
    //   })
    // }
  // }

  onContentScroll = () => {
    const questionShown = this.scartContent.scrollTop > 110;
    this.setState({
      questionShown
    });
    // console.log('this.props.questionNoClicked', this.props.questionNoClicked);
    if (questionShown && this.props.questionNoClicked) {
      this.needToShowQuestionAgain = true;
    }
    if (this.scartContent.scrollTop === 0 && this.needToShowQuestionAgain) {
      this.needToShowQuestionAgain = false;
      this.props.clickQuestionNo(false);
    }
  };

  handleResize = () => {
    if (!this.props.userPopupOpened) {
      clearTimeout(this.resizeId);
      this.resizeId = setTimeout(this.changeContainerHeight, 100);
    }
  };

  changeContainerHeight = () => {
    this.setState({
      containerHeight: window.innerHeight + document.body.scrollTop
    })
  };

  handleNoClick = () => {
    Analytics.sendClickEvent("mobile-shopping-cart-no");
    this.setState({
      questionShown: true
    });
    this.props.clickQuestionNo(true);
  };

  handlePaneClick = (activePaneIndex, activePane) => {
    Analytics.sendClickEvent("shopping-cart-pane");
    this.setState({
      activePaneIndex,
      activePane,
    });

    const $activePaneTitle = $(`.scart-block__title[data-title='${activePane.toLowerCase().replace(" ", "-")}']`);
    if ($activePaneTitle) {
      const $scartContent = $(this.scartContent);
      const scrollTo = $scartContent.scrollTop() + $activePaneTitle.offset().top - 70 + (this.props.questionNoClicked ? 70 : 0);
      // console.log('$activePaneTitle', $activePaneTitle);
      // console.log('scrollTo', scrollTo);
      $scartContent.animate({scrollTop: scrollTo}, 800);
    }
  };

  goBack = () => {
    switch (this.props.cameFromPage) {
      case 'visualizer':
        this.props.toggleBathroomVisualizerOpen(true);
        if (!window.location.href.includes("visualizer")) {
          hashHistory.push("visualizer");
        }
        break;
      case 'materials': {
        const layout = getCurrentLayout();
        layout.qtCategories ? changeQTRoutePath() : hashHistory.push('materials');
        this.props.toggleSelectionWindow(true, this.props.selectionGroup);
        break;
      }
      case 'quote-design':
      default:
        hashHistory.push('quote-design');
        break;
    }
    this.props.setCameFromPage('');
  };

  openInstallationView = () => {
    Analytics.sendClickEvent("shopping-cart-open-installation");
    this.props.toggleInstOpened(true);
  };

  renderCanvasPosition = (hardcodedImage, showRecentlyViewedItems, recentlyItems) => {
    if (hardcodedImage) {
      return null
    }
    if (showRecentlyViewedItems) {
      return <RecentlyViewedItems recentlyItems={recentlyItems} isMobile={true}/>
    }
    return <ShoppingCartCanvas/>
    // <MobileCanvas activePane={this.state.activePane} layout={layout}/>
  };

  render() {
    // console.log('this.props.cartItems', this.props.cartItems);
    const mobileSafari = (this.props.windowWidth <= 991) && (this.props.windowWidth > 480) && browserIsSafari();
    const selectionBodyStyles = mobileSafari ? {height: this.state.containerHeight} : {};

    const fabricatorSettings = this.props.fabricatorSettings;
    const allowInstallations = fabricatorSettings.addLaborCustomer
      || (document.kvConfig.isBackend && fabricatorSettings.addLaborInstaller);
    const showInstallations = allowInstallations && this.props.instList.length
      && (!this.props.showUnlockCalculations || (this.props.unlockCalculationsStep >= 2)) // tutorial
      && this.props.instList.some((instGroup) => instGroup.services.some(service => !service.autoAddWithProduct));

    let recentlyItems = [];
    let showRecentlyViewedItems = fabricatorSettings.showRecentlyViewedItems;
    if (showRecentlyViewedItems) {
      recentlyItems = this.getRecentlyViewedItems();
      showRecentlyViewedItems = recentlyItems.length > 0;
    }

    const cartItemsLength = this.props.cartItems.length;
    const {showMobileQuotes, showAdvancedQuoting, staticCanvasImage} = this.props;

    const showPriceWorksheet = !(this.props.discountsReceived && !this.props.discountSections.length)
      && document.kvConfig.isBackend;

    return (
      <div className={"scart" + (recentlyItems.length ? " scart--with-recently" : "")
      + (showAdvancedQuoting && !showMobileQuotes ? " scart--advanced scart--full-width" : "")}
           style={selectionBodyStyles}>
        <div className="scart-main">
          <div className={"scart-main__left" + (staticCanvasImage ? " scart-main__left--relative" : "")}>
            <NoInternetOverlay/>
            <HardcodedCanvasImage/>
            {this.renderCanvasPosition(staticCanvasImage, showRecentlyViewedItems, recentlyItems)}
          </div>
          <div className="scart-main__right">
            <ShoppingCartMobileHeader questionShown={this.state.questionShown}/>
            <div className={"scart-content" + (!cartItemsLength && !showMobileQuotes ? " scart-content--empty" : "")}
                 ref={(el) => this.scartContent = el}>
              {showMobileQuotes ? <Quotes/> : null}
              {showInstallations && !showMobileQuotes
                ? <ShoppingCartInstallationQuestion questionNoClicked={this.props.questionNoClicked}
                                                    handleNoClick={this.handleNoClick}
                                                    openInstallationView={this.openInstallationView}/>
                : null}
              {showMobileQuotes ? null : <ShoppingCartItemsList/>}
              {cartItemsLength && fabricatorSettings.depositDisclaimer && fabricatorSettings.enableDisclaimer
              && !showMobileQuotes && (!this.props.showUnlockCalculations || (this.props.unlockCalculationsStep === 4))
                ? <DepositDisclaimer/>
                : null}
            </div>
          </div>
        </div>
        <ShoppingCartFooter recentlyItems={[]} showRecentlyViewedItems={false}/>
        {/*<ShoppingCartMobileFooter activePane={this.state.activePane}*/}
        {/*                          handlePaneClick={this.handlePaneClick}*/}
        {/*                          goBack={this.goBack}*/}
        {/*                          recentlyItems={recentlyItems}*/}
        {/*                          activePaneIndex={this.state.activePaneIndex}/>*/}
        {showInstallations ? <InstView/> : null}
        {showPriceWorksheet ? <PriceWorksheetView/> : null}
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  const {cartItems, questionNoClicked, cameFromPage, recentlyViewedItems, showMobileQuotes} = store.cartState;
  const {staticCanvasImage, bvOpened} = store.bathroomVisualizerState;
  const {financePaymentType, discountSections, discountsReceived} = store.priceWorksheetState;

  return {
    cartItems,
    instList: store.instState.instList,
    questionNoClicked,
    selectionGroup: store.selectionState.selectionGroup,
    cameFromPage,
    windowWidth: store.serverState.windowWidth,
    userPopupOpened: store.userState.userPopupOpened,
    userIsLoggedIn: store.userState.userIsLoggedIn,
    isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
    fabricatorSettings: store.fabricatorState.settings,
    bvOpened,
    recentlyViewedItems,
    showUnlockCalculations: store.unlockCalculationsState.showUnlockCalculations,
    unlockCalculationsStep: store.unlockCalculationsState.unlockCalculationsStep,
    showMobileQuotes,
    showAdvancedQuoting: store.advancedQuotingState.showAdvancedQuoting,
    staticCanvasImage,
    discountSections,
    discountsReceived,
    financePaymentType,
  };
};

export default connect(mapStateToProps, {
  clickQuestionNo,
  setCameFromPage,
  toggleSelectionWindow,
  toggleBathroomVisualizerOpen,
  toggleInstOpened,
  togglePriceWorksheetOpened,
})(ShoppingCartMobile);
